import { IEntity } from 'app/projects/entity/src/lib/interfaces/entity.interface';
import { IImageLibraryQuery } from '../interfaces/image-library.query.interface';

export class ImageLibrary implements IEntity {
    static label_singular = 'image-library';
    static label_plural = 'image-libraries';

    static props_to_search = ['name'];

    id: string;
    configKey: string;
    configVal: { app_id: string; my_images: boolean; tenant_library: boolean; unsplash: boolean };

    constructor(query?: IImageLibraryQuery) {
        if (query) {
            this.id = query.id.toString();
            this.configKey = query.config_key;
            this.configVal = query.config_value;
        }
    }
}
